module.exports = __webpack_public_path__ + "static/mickaelHEBERT-01d821c83fb6d93a71058fb62bf7e395.jpeg";